import PropTypes from 'prop-types';
import { useState } from 'react';
import { Button, Typography } from '@mui/material';
import EScriptRequestView from 'modules/RequestStatus/components/EScriptOrders/PomRequestView';

const OrderEventHistoryButton = ({ referenceId, orderId, requestId, mpi, partnerId }) => {
  const [openHistory, setOpenHistory] = useState(false);

  const handleOpen = () => {
    setOpenHistory(true);
  };
  const handleClose = () => setOpenHistory(false);

  return (
    <>
      <Button
        size='small'
        variant='outlined'
        color='secondary'
        sx={{
          px: 1,
          minHeight: 30,
          fontSize: '0.75rem',
          lineHeight: 'normal',
        }}
        onClick={handleOpen}
      >
        <Typography variant='small' color='secondary'>
          View Order History
        </Typography>
      </Button>
      <EScriptRequestView
        open={openHistory}
        requestId={requestId}
        referenceId={referenceId}
        onClose={handleClose}
        orderId={orderId}
        mpi={mpi}
        partnerId={partnerId}
        fromPatientProfile
      />
    </>
  );
};
OrderEventHistoryButton.propTypes = {
  referenceId: PropTypes.string.isRequired,
  orderId: PropTypes.string.isRequired,
  requestId: PropTypes.string.isRequired,
  mpi: PropTypes.string.isRequired,
  partnerId: PropTypes.string.isRequired,
};

export default OrderEventHistoryButton;
